import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootDetailsTabId } from './RootDetailsTabId';

type RootDetailsTabState = {
  [rootId: string]: RootDetailsTabId;
};

export const rootDetailsTabsSlice = createSlice({
  name: 'rootTabs',
  initialState: {} as RootDetailsTabState,

  reducers: {
    setSelectedTab: (
      state,
      { payload: { rootId, tabId } }: PayloadAction<{ rootId: string; tabId: RootDetailsTabId }>,
    ) => {
      state[rootId] = tabId;
    },
  },

  selectors: {
    selectedTab: (state, rootId: string) => state[rootId] ?? 'portfolioSummary',
  },
});

export const rootDetailsTabsActions = rootDetailsTabsSlice.actions;

export const rootDetailsTabsSelectors = rootDetailsTabsSlice.selectors;
